import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import theme from "src/theme";
import {
  Grid,
  Typography,
  Button,
  CircularProgress,
  Link,
  Select,
  MenuItem,
  Box,
  InputLabel,
  makeStyles,
  Snackbar
} from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import logo from "src/assets/images/conexoplus.png";

import { resetarSenha } from "src/store/actions/usuario";
import * as types from "src/store/types/usuario";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "grid",
    gridTemplateAreas: "'logo form'",
    gridTemplateRows: "100vh",
    gridTemplateColumns: "1fr 1fr",
    [theme.breakpoints.down("sm")]: {
      gridTemplateAreas: "'logo''form'",
      gridTemplateColumns: "1fr",
      gridTemplateRows: "30vh 50vh",
    },
  },
  logo: {
    gridArea: "logo",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      alignItems: "flex-end",
    },
  },
  form: {
    gridArea: "form",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
    },
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function ResetarSenha() {
  const { token } = useParams();
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading } = useSelector(
    (state) => state.usuario
  );
  const [data, setData] = useState({ password: "", repeatPassword: "", token: token });
  const [openError, setOpenError] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);

  ValidatorForm.addValidationRule('isPasswordMatch', (value) => {
    if(value !== data.password)
      return false;
    else
      return true;   
  });

  const handleCloseError = () => {
    setOpenError(false);
  }
  const handleCloseSuccess = () => {
    setOpenSuccess(false);
  }

  const handleResetarSenha = async () => {
    dispatch({ type: types.USUARIO_LOADING, payload: true });
    try {
      await resetarSenha(data.password, data.token);
      setOpenSuccess(true);
      setTimeout(() => {
        navigate('/');
      }, 5000);
    
    } catch(error) {
      setOpenError(true);
    }
  }

  return (
    <Box className={classes.container}>
      <Box className={classes.logo}>
        <img
          src={logo}
          alt="Logomarca Conexo Mais"
          style={{ width: 280, height: 120 }}
        />
      </Box>
      <Box className={classes.form}>
        <Snackbar open={openError} autoHideDuration={5000} onClose={handleCloseError} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
          <Alert onClose={handleCloseError} severity="error">
            Não foi possível alterar sua senha.
          </Alert>
        </Snackbar>
        <Snackbar open={openSuccess} autoHideDuration={5000} onClose={handleCloseSuccess} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
          <Alert onClose={handleCloseSuccess} severity="success">
            Senha alterado com successo! Você está sendo direcionado para o login...
          </Alert>
        </Snackbar>
        <ValidatorForm
          onSubmit={handleResetarSenha}
          onError={(errors) => console.log(errors)}
          style={{ width: "clamp(300px, 100%, 500px)" }}
        >
          <Typography variant="h2">Digite uma nova senha</Typography>
          <Grid container spacing={2} style={{ marginTop: 20 }}>
            <Grid item sm={12}>
              <TextValidator
                fullWidth
                label="Senha"
                name="password"
                value={data.password}
                onChange={(event) =>
                  setData({
                    ...data,
                    password: event.target.value,
                  })
                }
                type="password"
                validators={["required"]}
                errorMessages={["Este campo é obrigatório"]}
                variant="outlined"
              />
            </Grid>
            <Grid item sm={12}>
              <TextValidator
                fullWidth
                label="Confirmar Senha"
                name="repeatPassword"
                value={data.repeatPassword}
                onChange={(event) =>
                  setData({
                    ...data,
                    repeatPassword: event.target.value,
                  })
                }
                type="password"
                validators={["required", "isPasswordMatch"]}
                errorMessages={["Este campo é obrigatório", "As senhas devem ser iguais"]}
                variant="outlined"
              />
            </Grid>
          </Grid>
          {loading ? (
            <CircularProgress
              style={{
                display: "block",
                width: 45,
                height: 45,
                marginTop: 25,
                marginLeft: "auto",
                marginRight: "auto",
              }}
            />
          ) : (
            <div>
              <Button
                type="submit"
                style={{
                  marginTop: 25,
                  width: "100%",
                  "&:hover": {
                    backgroundColor: theme.palette.common.rozaPtz,
                  },
                }}
                color="primary"
                size="large"
                variant="contained"
              >
                Confirmar Nova Senha
              </Button>
            </div>
          )}
          <Typography
            variant="body1"
            style={{
              marginTop: 10,
              color: theme.palette.text.secondary,
            }}
          >
          </Typography>
        </ValidatorForm>
      </Box>
    </Box>
  );
}

export default ResetarSenha;